
import {getFundReport,listDataFundReport} from "@/zsm-api-new/fund.js"
import {getFund,incomeListFund,withdrawFund,withdrawList} from '@/zsm-api-new/fund.js'
const state = {

}

const mutations = {

}

const actions = {
  // 获取某人某个时间段内的数据
    listDataFundReport({ commit }, info) {
      return new Promise((resolve, reject) => {
        listDataFundReport(info).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
// 获取某人某天资金数据
  getFundReport({ commit }, info) {
    return new Promise((resolve, reject) => {
      getFundReport(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 个人资金信息
  getFund({ commit }, id) {
    return new Promise((resolve, reject) => {
      getFund(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 讲师收益列表
  incomeListFund({ commit }, info) {
    return new Promise((resolve, reject) => {
      incomeListFund(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 提现
  withdrawFund({ commit }, info) {
    return new Promise((resolve, reject) => {
      withdrawFund(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 提现记录
  withdrawList({ commit }, info) {
    return new Promise((resolve, reject) => {
      withdrawList(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
